import { render, staticRenderFns } from "./EditUserProfile.vue?vue&type=template&id=6e61eab2&scoped=true&"
import script from "./EditUserProfile.vue?vue&type=script&lang=ts&"
export * from "./EditUserProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e61eab2",
  null
  
)

export default component.exports